const requestActionTypes = {
  RESET_STATE: 'RESET_STATE',
  SELF_REGISTRATION_REQUEST: 'SELF_REGISTRATION_REQUEST',
  REQUEST_STATUS_SUCCESS: 'REQUEST_STATUS_SUCCESS',
  REQUEST_STATUS_FAILURE: 'REQUEST_STATUS_FAILURE',
};

export { requestActionTypes as default };
